import React from "react"
import PropTypes from "prop-types"

const SVG = ({ className, size }) => (
  <svg viewBox="0 0 468.293 468.293" className={className} {...size}>
    <path
      d="M467.129 262.211s22.522 125.788-130.604 170.574l-9.491-223.723L434.15 35.507l10.999 12.735a75.781 75.781 0 0 1 18.413 47.906l3.567 166.063z"
      fill="#dc8744"
    />
    <path
      d="M434.15 35.507s105.76 74.574-107.116 173.555L1.222 64.796c-1.967-.871-1.437-3.797.71-3.923L434.15 35.507z"
      fill="#fcd462"
    />
    <path
      d="M328.436 209.062L0 62.867v44.403c0 2.371 2.335 3.974 4.57 3.182 3.396-1.204 7.028-1.897 10.847-1.897 18.53 0 33.552 14.906 33.552 33.293s-15.021 33.294-33.552 33.294c-3.819 0-7.451-.693-10.847-1.898-2.235-.793-4.57.81-4.57 3.182v10.534c0 1.774 1.37 3.171 3.131 3.384 18.359 2.223 32.603 17.646 32.603 36.465 0 18.82-14.244 34.243-32.604 36.466-1.76.212-3.13 1.609-3.13 3.382v19.691l338.001 146.437-9.565-223.723z"
      fill="#f6c358"
    />
    <g fill="#dc8744">
      <ellipse cx="187.998" cy="88.482" rx="33.386" ry="10.321" />
      <ellipse cx="243.281" cy="122.256" rx="27.348" ry="8.454" />
      <ellipse cx="327.037" cy="152.364" rx="27.348" ry="8.454" />
      <ellipse cx="338.245" cy="91.948" rx="44.6" ry="13.787" />
      <path d="M208.655 210.185c-12.05 2.608-20.658 19.321-20.658 37.641s8.608 35.033 20.658 37.641c13.988 3.027 27.093-13.614 27.093-37.641s-13.105-40.668-27.093-37.641zM268.314 296.747c-8.666 1.875-14.857 13.896-14.857 27.071s6.191 25.195 14.857 27.071c10.06 2.177 19.485-9.791 19.485-27.071 0-17.279-9.425-29.247-19.485-27.071zM131.007 224.921c-7.333 1.587-12.571 11.757-12.571 22.905s5.238 21.318 12.571 22.905c8.512 1.842 16.487-8.284 16.487-22.905s-7.976-24.747-16.487-22.905zM98.118 147.437c-7.333 1.587-12.571 11.757-12.571 22.905s5.238 21.318 12.571 22.905c8.512 1.842 16.487-8.284 16.487-22.905s-7.975-24.747-16.487-22.905zM65.666 224.921c-7.333 1.587-12.571 11.757-12.571 22.905s5.238 21.318 12.571 22.905c8.512 1.842 16.487-8.284 16.487-22.905s-7.975-24.747-16.487-22.905z" />
    </g>
  </svg>
)

SVG.propTypes = {
  size: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number,
  }),
}

export default SVG
